import { httpApi } from '@app/api/http.api'

export type NotificationTemplateRequest = {
  name: string
  subjectPL: string
  subjectEN: string
  emailContentPL: string
  emailContentEN: string
  smsContentPL: string
  smsContentEN: string
}

export type NotificationTemplateResponse = {
  id: string
  name: string
  subjectPL: string
  subjectEN: string
  emailContentPL: string
  emailContentEN: string
  smsContentPL: string
  smsContentEN: string
  createdAt: string
  updatedAt: string
}
const NOTIFICATION_TEMPLATES = '/notification-templates'

export const getAllNotificationTemplates = (): Promise<NotificationTemplateResponse[]> =>
  httpApi.get(`${NOTIFICATION_TEMPLATES}/all`).then(({ data }) => data)

export const getNotificationTemplateById = (id: string): Promise<NotificationTemplateResponse> =>
  httpApi.get(`${NOTIFICATION_TEMPLATES}/${id}`).then(({ data }) => data)

export const createNotificationTemplate = (templateData: NotificationTemplateRequest): Promise<string> =>
  httpApi.post(`${NOTIFICATION_TEMPLATES}/create-template`, templateData).then(({ data }) => data)

export const updateNotificationTemplate = (
  id: string,
  templateData: Partial<NotificationTemplateRequest>,
): Promise<void> => httpApi.put(`${NOTIFICATION_TEMPLATES}/update/${id}`, templateData).then(() => {})

export const deleteNotificationTemplate = (id: string): Promise<void> =>
  httpApi.delete(`${NOTIFICATION_TEMPLATES}/${id}`).then(() => undefined)

export const toggleNotificationTemplateActive = (id: string): Promise<NotificationTemplateResponse> =>
  httpApi.put(`${NOTIFICATION_TEMPLATES}/${id}/toggle-active`).then(({ data }) => data)
